/**
 *
 * @param {import("./Spinner.js")} spinner
 * @param {HTMLElement} node
 * @param {HTMLElement} [subjectNode]
 * @class
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
function Layer(spinner, node, subjectNode) {
  this.spinner = spinner;
  this.host = node;
  this.subject = null;
  this._available = true;
  this._smoothTransform = this.host.classList.contains("motion");
  this._visibility = this.host.style.display !== "none";
  this._activeAnimation = null;
  this.subjectChildren = {};

  this.setSubject(subjectNode ?? this.host.firstElementChild);
  this.host.style.display = null;
}

Layer.prototype = {
  get imagesBaseUrl() {
    return this.spinner.imagesBaseUrl;
  },

  get available() {
    return this._available;
  },

  set available(flag) {
    this._available = flag;
    this.visibility = this._visibility;
  },

  get opacity() {
    return this.host.style.opacity;
  },
  /**
   *
   * @param {boolean} value
   */
  set visibility(value) {
    this._visibility = value;

    if (this._available) {
      this.host.style.display = value ? null : "none";
    } else {
      this.host.style.display = "none";
    }
  },

  get visibility() {
    if (this._available) {
      return this._visibility;
    } else {
      return false;
    }
  },

  get subjectOpacity() {
    return this.subject.style.opacity;
  },

  set smoothTransform(value) {
    this._smoothTransform = value;
    if (value) {
      this.host.classList.add("motion");
    } else {
      this.host.classList.remove("motion");
    }
  },

  get smoothTransform() {
    return this._smoothTransform;
  },

  set disabled(value) {
    if (value) {
      this.host.classList.add("disabled");
    } else {
      this.host.classList.remove("disabled");
    }
  },

  get disabled() {
    return this.host.classList.contains("disabled");
  },

  set cssText(value) {
    this.subject.style.cssText = value;
  },

  get cssText() {
    return this.subject.style.cssText;
  },

  setSubject(subject) {
    if (this.subject) {
      this.host.removeChild(this.subject);
    }

    this.host.insertBefore(subject, this.host.firstChild);
    this.subject = subject;

    // child nodes that have id
    for (const child of this.subject.children) {
      if (child.id) {
        this.subjectChildren[child.id] = child;
      }
    }
  },

  on(event, callback, options) {
    this.host.addEventListener(event, callback, options);
  },

  off(event, callback, options) {
    this.host.removeEventListener(event, callback, options);
  },

  appendToSubject(element) {
    return this.subject.appendChild(element);
  },

  appendTo(element, childId) {
    return this.subjectChildren[childId].appendChild(element);
  },

  /**
   *
   * @param {object} css
   * @returns {Animation}
   */
  animate(css) {
    if (!this._smoothTransform || !this._visibility) {
      if (this._activeAnimation) this._activeAnimation.cancel();
      this.cssText = "";
      Object.assign(this.subject.style, css);

      return null;
    }

    if (this._activeAnimation) {
      this._activeAnimation.commitStyles();
      this._activeAnimation.cancel();
    }

    this._activeAnimation = this.subject.animate(css, {
      duration: 100,
      fill: "both",
      easing: "linear",
    });

    this._activeAnimation.finished
      .then(() => {
        this._activeAnimation.commitStyles();
      })
      .catch(() => {
        // Do nothing
      });

    return this._activeAnimation;
  },
};

export default Layer;
